<template>
  <div class="h-100">
    <NavBarComponent/>
    <PushComponent/>
  </div>
</template>

<script>
// @ is an alias to /src
import PushComponent from '../components/PushComponent'
import NavBarComponent from '../components/NavBarComponent'

export default {
  name: 'home',
  components: {PushComponent,NavBarComponent}
   
}
</script>
